import type { ParticipationReport } from '@efdigital/ll-addon-data';

export type ParticipationReportPerspective = 'coach' | 'coachee';

const LABELS: Record<
  ParticipationReportPerspective,
  Record<ParticipationReport, string>
> = {
  coach: {
    session_delivered: 'We had the session.',
    i_did_not_attend: 'I did not attend.',
    other_did_not_attend: 'The coachee did not attend.',
    reported_issue: 'Something went wrong — please review.',
  },
  coachee: {
    session_delivered: 'We had the session.',
    i_did_not_attend: 'I did not attend.',
    other_did_not_attend: 'The coach did not attend.',
    reported_issue: 'Something went wrong — please review.',
  },
};

export function participationReportLabel(
  report: ParticipationReport,
  perspective: ParticipationReportPerspective
): string {
  return LABELS[perspective][report];
}

export const PARTICIPATION_REPORT_OPTIONS: ParticipationReport[] = [
  'session_delivered',
  'i_did_not_attend',
  'other_did_not_attend',
  'reported_issue',
];
